import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Balance from "./components/Balance";
import Form from "./components/Form";
import Layout from "./components/Layout";
import Search from "./components/Search";
import AllItems from "./components/Transactions/AllItems";
// import Item from "./components/Transactions/Item";
import Transactions from "./components/Transactions/Transactions";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Balance />
              <Form />
              <Transactions />
            </Layout>
          }
        ></Route>
        <Route
          path="/items"
          element={
            <Layout>
              <Search />
              <AllItems />
            </Layout>
          }
        ></Route>
      </Routes>
    </Router>
  );
}

export default App;
